import * as types from '../constants'

const initialState = {
    modalProps: {
        open: false
    },
    modalType: null
}

export default (state = initialState, action) => {
    switch (action.type) {
        case types.SHOW_MODAL:
            return {
                ...state,
                modalProps: action.modalProps,
                modalType: action.modalType,
                type: action.type
            }
        case types.HIDE_MODAL:
            return initialState
        default:
            return state;
    }
}